export const authRole = {
  admin: ['admin'],
  user: ['user', 'admin'],
};

export const routePermittedRole = {
  admin: 'admin',
  user: 'user',
};
export const debounceTime = 500;
export const defaultUser = {
  displayName: 'John Alex',
  email: 'demo@example.com',
  token: 'access-token',
  role: 'user',
  photoURL: '/assets/images/avatar/A11.jpg',
};
export const status = {
  active: 'Active',
  inactive: 'In Active',
};
export const paymentStatus = {
  paid: 'Paid',
  failed: 'Failed',
};
export const entities = {
  customer: 'Customer',
  business: 'Business',
  product: 'Product',
  accountHistory: 'Account History',
  rewardHistory: 'Reward History',
  stampHistory: 'Stamp History',
  promotions: 'Promotions',
  stampCard: 'Stamp Card',
};
export const initialUrl = '/dashboard'; // this url will open after login
export const defaultPageSize = 10;
export const days = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
];

export const breadcrumbs = {
  dashBoard: {
    label: 'Home',
    link: '/dashboard',
  },
  businessManagement: {
    label: 'Business Management',
    link: '/business-management',
  },
  analytics: {
    label: 'Analytics',
    link: '/analytics/dashboard',
  },
  stampCard: {
    label: 'Stamp Card',
    link: '/stamp-card',
  },
  customer: {
    label: 'Customers',
    link: '/customer',
  },
  businessTypes: {
    label: 'Business Types',
    link: '/config/business-types',
  },
  ProductTypes: {
    label: 'Product Types',
    link: '/config/product-types',
  },
  termsAndConditions: {
    label: 'Terms and Conditions',
    link: '/terms-and-conditions',
  },
  privacyPolicy: {
    label: 'Privacy Policy',
    link: '/privacy-policy',
  },
};

export const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const analytics_value = {
  count: 'count',
  barChart: 'bar_chart',
  pieChart: 'pie_chart',
  table: 'table',
};

export const defaultCurrency = '£';
